<template>
  <div class="menu-main">
    <!-- <van-nav-bar
      :title="$route.meta.title"
      left-text="返回"
      @click-left="$router.back()"
      left-arrow
      :fixed="true"
    /> -->
    <!-- 头部时间选择 -->
    <div class="header-calendar-select">
      <div class="head-tabar">
        <div
          class="time-item"
          :class="[timeIndex == index ? 'selectTime' : '']"
          v-for="(item, index) in dateArr"
          :key="index"
          @click="handleChangeTime(index, item)"
        >
          <div>{{ item.substring(5, 10) }}</div>
          <div class="time-week">
            {{ $t("week_" + item.substring(12, 13)) }}
          </div>
        </div>
      </div>
      <div class="calendar-main" @click="showSelectCalendar = true">
        <van-icon name="notes-o" size="19" />
        <span>{{ $t("calendar") }}</span>
      </div>
    </div>
    <!-- 餐段选择 -->
    <div class="meal-period" v-if="productCateforyList.length > 0">
      <div
        class="meal-item"
        :class="[mealIndex == index ? 'selectMeal' : '']"
        v-for="(item, index) in mealPeriod"
        :key="index"
        @click="handleSelectMeal(index, item)"
      >
        <div>{{ item.mealHourName }}</div>
        <!-- <div>{{ item.mealHourTime }}</div> -->
        <!-- <div style="background: #2071c5; height: 1px; width: 22px"></div> -->
      </div>
    </div>
    <!-- 主体 -->
    <div class="select-menu-main" v-if="productCateforyList.length > 0">
      <!-- 左 -->
      <div class="left-side">
        <div
          v-for="(item, index) in productCateforyList"
          :key="item.categoryId"
        >
          <div
            class="menu-item"
            :class="[selectedMenuId == index ? 'm-item-active' : '']"
            @click="handleChangeLeftSide(index)"
          >
            <div class="m-item-title left-item-title">
              {{ language == "CN" ? item.categoryName : item.categoryNameEn }}
            </div>
          </div>
        </div>
      </div>
      <!-- 右 -->
      <div class="right-side" ref="content">
        <div>
          <div
            v-for="(item, index) in productCateforyList"
            :id="'id' + index"
            :key="item.categoryId"
          >
            <div class="dish-title">
              {{ language == "CN" ? item.categoryName : item.categoryNameEn }}
            </div>
            <div
              class="dish-item"
              v-for="(menu, index) in item.productList"
              :key="index"
            >
              <div class="dish-item-wrp">
                <div class="dish-item-pic">
                  <img
                    :src="
                      menu.productpic == ''
                        ? (language == 'CN' ? require('../../assets/noimg.jpeg') : require('../../assets/noimg-en.jpg'))
                        : menu.productpic
                    "
                    alt=""
                  />
                </div>
                <div class="dish-item-info">
                  <div class="dish-item-name">
                    {{ language == "CN" ? menu.name : menu.nameEn || menu.name }}
                  </div>
                  <!-- <div class="dish-item-sales">剩余{{ menu.productNum }}份</div> -->
                  <!-- <div class="dish-item-sales">
                    {{
                      menu.productPurchasingNum == "0"
                        ? "不限量"
                        : "限" + menu.productPurchasingNum + "份"
                    }}
                  </div> -->
                  <!-- <div class="dish-item-sales" v-if="menu.description">
                    {{ menu.description }}
                  </div> -->
                  <div
                    class="dish-item-money"
                    v-if="menu.price == menu.vipprice"
                  >
                    ￥{{ (menu.price / 100).toFixed(2) }}
                  </div>
                  <div class="preferential" v-else>
                    <div class="vipPrice">
                      ¥{{ (menu.vipprice / 100).toFixed(2) }}
                    </div>
                    <div class="menuPrice">
                      ¥{{ (menu.price / 100).toFixed(2) }}
                    </div>
                  </div>
                </div>
                <div class="dish-item-count" v-if="menu.productNum > 0">
                  <div
                    class="dish-item-tab"
                    :class="[menu.count > 0 ? 'showMinus' : 'hiddenMinus']"
                    @click.stop="handleMinusCount(menu)"
                  >
                    <img
                      class="count-pic"
                      src="../../assets/imgs/minus.png"
                      alt=""
                    />
                  </div>
                  <div
                    class="dish-item-tab show__meal_count"
                    :class="[menu.count > 0 ? 'showMinus' : 'hiddenMinus']"
                    @click="handleSelectMenuCount(menu)"
                  >
                    {{ menu.count }}
                  </div>
                  <div class="dish-item-tab" @click.stop="handleAdd(menu)">
                    <img
                      class="count-pic"
                      src="../../assets/imgs/madd.png"
                      alt=""
                    />
                  </div>
                </div>
                <div class="pay-null" v-else>{{ $t("soldOut") }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="nullImg" v-if="productCateforyList.length == '0'">
      <img
        style="width: 140px; height: 140px"
        :src="language == 'CN' ? require('../../assets/without.png') : require('../../assets/without-en.jpg')"
        alt=""
      />
    </div>
    <!-- 底部 -->
    <!-- <div class="call-info">
      <span>{{ $t("currentCall") }}：{{ WaitingISNum }}</span>
      <span class="peo-c">{{ $t("currentPeople") }}：{{ peopleNum }}</span>
      <span class="peo-c">{{ $t("estimatedTime") }}：{{ estimatedTime }}</span>
    </div> -->

    <div class="footer-main" v-if="productCateforyList.length > 0">
      <div class="footImg" @click="handleShowShoping">
        <img src="@/assets/shop.png" alt="" />
        <div class="menu-nun" v-if="selectMenuCount > 0">
          {{ selectMenuCount < 100 ? selectMenuCount : "99+" }}
        </div>
      </div>
      <div class="menu-prompt" v-if="selectShopList.length == 0">
        {{ $t("orderPrompt") }}
      </div>
      <div class="menu-prompt menu-price" v-else>￥{{ computeCount }}</div>
      <div
        class="place-order active-btn"
        @click="handleSubmitOrder"
        v-if="computeSendPrice || countSendPrice == '0'"
      >
        {{ $t("goOrder") }}
      </div>
      <div class="place-order" v-else>
        {{ $t("lifting", [countSendPrice || 0]) }}
      </div>
    </div>
    <!-- 购物车弹窗 -->
    <van-popup v-model="shopShow" position="bottom" :style="{ height: '40%' }">
      <div class="shop-main">
        <div class="shop-head">
          <div>{{ $t("selectedGoods") }}</div>
          <div @click="handleClearShop">{{ $t("clearCart") }}</div>
        </div>
        <div class="shop-item" v-for="item in selectShopList" :key="item.id">
          <div class="item-name">
            {{ language == "CN" ? item.name : item.nameEn || item.name }}
          </div>
          <div class="price-count">
            <div class="price" v-if="item.price == item.vipprice">
              ￥{{ ((item.price / 100) * item.count).toFixed(2) }}
            </div>
            <div v-else class="price">
              ￥{{ ((item.vipprice / 100) * item.count).toFixed(2) }}
            </div>
            <div class="selectCount">
              <div
                style="width: 25px; height: 25p; line-height: 0"
                @click="handleLoseShopCount(item)"
              >
                <img
                  style="width: 25px; height: 25px"
                  src="../../assets/imgs/minus.png"
                  alt=""
                />
              </div>
              <div class="num">{{ item.count }}</div>
              <div
                style="width: 25px; height: 25px; line-height: 0"
                @click="handleAddShopCount(item)"
              >
                <img
                  style="width: 25px; height: 25px"
                  src="../../assets/imgs/madd.png"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
        <div v-if="selectShopList.length == 0" class="notMenul">
          {{ $t("noSelectShop") }}
        </div>
      </div>
    </van-popup>
    <!-- 设置数量 -->
    <van-dialog
      v-model="showMenuDesciption"
      :title="$t('editNum')"
      show-cancel-button
      :cancelButtonText="$t('orderCancel')"
      :confirmButtonText="$t('confirm')"
      @confirm="handleConfirmCount"
    >
      <div style="padding: 12px">
        <van-field
          style="border: 1px solid #eee"
          v-model="placeCount"
          type="digit"
          :placeholder="$t('enterOrderQuantity')"
        />
      </div>
    </van-dialog>
    <!-- 选择日历 -->
    <van-calendar
      v-model="showSelectCalendar"
      color="#1989fa"
      :title="$t('calendarTitle')"
      @confirm="handleConfirmSelectCalendar"
      :show-confirm="false"
      :max-date="maxDate"
    />
  </div>
</template>
<script>
import utils from "../../utils/filter";
export default {
  data() {
    return {
      showSlogan: false,
      weekDay: ["周日", "周一", "周二", "周三", "周四", "周五", "周六"],
      timeIndex: 0,
      mealPeriod: [],
      mealIndex: 0,
      selectMenuCount: 0,
      selectedMenuId: 0,
      productCateforyList: [],
      productCateList: [],
      allCateList: [],
      shopShow: false,
      selectShopList: [],
      listBoxState: true,
      dateArr: [], //上方日期
      mealPeriodTime: "",
      selectMealList: [],
      mealHourName: "",
      mealHourTime: "",
      shopId: "",
      branchId: "",
      branchName: "",
      sendPrice: "",
      totalPrice: "",
      priceMinus: "",
      minusFlag: false,
      searchText: "",
      newList: [],
      showMenuDesciption: false,
      dblCount: 0,
      menuDescription: "",
      placeCount: null,
      selectCountRow: {},
      WaitingISNum: "",
      peopleNum: "",
      estimatedTime: "",
      language: "",
      showSelectCalendar: false,
      maxDate: new Date(),
      productKey: 0,
    };
  },
  beforeRouteLeave(to, from, next) {
    if (
      to.path == "/card/selectBranch" ||
      to.path == "/order/list" ||
      to.path == "/me/index" ||
      to.path == "/nutitron/home" ||
      to.path == "/page"
    ) {
      this.$vnode.parent.componentInstance.cache = {};
      this.$vnode.parent.componentInstance.keys = [];
    }
    next();
  },
  activated() {
    if (this.$route.query.type && this.$route.query.type == "1") {
      this.selectShopList = [];
      this.selectMenuCount = 0;
      for (let i = 0; i < this.productCateforyList.length; i++) {
        for (
          let j = 0;
          j < this.productCateforyList[i].productList.length;
          j++
        ) {
          this.productCateforyList[i].productList[j].count = 0;
        }
      }
      this.getMenuList();
    }
    let seleciTime = JSON.parse(sessionStorage.getItem("selectTime"));
    if (seleciTime) {
      sessionStorage.setItem("selectTime", JSON.stringify(seleciTime));
    } else {
      sessionStorage.setItem("selectTime", JSON.stringify(this.mealPeriod[0]));
    }
  },
  async created() {
    this.showSlogan = true;
    this.branchId = sessionStorage.getItem("branchId");
    this.branchName = sessionStorage.getItem("branchName");
    this.shopId = localStorage.getItem("shopId");
    this.language = localStorage.getItem("language");
    this.timeIndex = 0;
    this.mealIndex = 0;
    await this.createTime();
    await this.getDataList();
    this.mealPeriodTime = this.dateArr[0];
    await this.getMenuList();
    // await this.getQueueUp();
    // await this.getWatingNum();

    if (this.$route.params.againData) {
      this.selectShopList = [];
      const againData = this.$route.params.againData;
      againData.orderItemList?.map((item) => {
        this.selectShopList.push({
          id: item.productId,
          name: item.productName,
          nameEn: item.productNameEn,
          price: item.priceStr * 100,
          vipprice: item.vipPriceStr * 100,
          count: item.quantity,
        });
      });
      this.productCateList.forEach((category) => {
        category.productList.forEach((product) => {
          const match = this.selectShopList.find(
            (item) => item.id === product.id
          );
          if (match) {
            this.$set(product, "count", match.count);
          } else {
            this.$set(product, "count", 0);
          }
        });
      });
      this.productCateforyList = JSON.parse(JSON.stringify(this.productCateList));
      const validProductIds = this.productCateList.flatMap((category) =>
        category.productList.map((product) => product.id)
      );

      this.selectShopList = this.selectShopList.filter((item) =>
        validProductIds.includes(item.id)
      );
      this.selectMenuCount = this.selectShopList.length;
    }
  },
  mounted() {
    this._scrollEventListener = () => {
      // 页面滚动停止100毫秒后才会执行下面的函数。
      clearTimeout(this._timeId);
      this._timeId = setTimeout(() => {
        this && this.scrollToTop && this.scrollToTop();
      }, 100);
    };
    window.addEventListener("scroll", this._scrollEventListener, true);
  },
  deactivated() {
    window.removeEventListener("scroll", this._scrollEventListener);
  },
  computed: {
    computeCount() {
      let allCount = null;
      for (let i = 0; i < this.selectShopList.length; i++) {
        if (this.selectShopList[i].price == this.selectShopList[i].vipprice) {
          allCount +=
            this.selectShopList[i].price * this.selectShopList[i].count;
        } else {
          allCount +=
            this.selectShopList[i].vipprice * this.selectShopList[i].count;
        }
      }
      this.totalPrice = (allCount / 100).toFixed(2);
      return (allCount / 100).toFixed(2);
    },
    computeSendPrice() {
      let minus = this.sendPrice - this.totalPrice * 100;
      if (minus <= 0) {
        this.minusFlag = true;
      } else {
        this.minusFlag = false;
      }
      if (!this.selectShopList.length) {
        this.minusFlag = false;
      }
      return this.minusFlag;
    },
    countSendPrice() {
      this.priceMinus = this.sendPrice - this.totalPrice * 100;
      if (!this.selectShopList.length) {
        this.priceMinus = this.sendPrice;
      }
      return parseInt(this.priceMinus / 100);
    },
  },
  methods: {
    getDataList() {
      let data = {
        shopId: this.shopId,
        branchId: this.branchId,
      };
      this.$authAjax
        .post("/api/wxapp/reserve/getReserveMealRule", data)
        .then((res) => {
          const { data } = res.data;
          let dayCount = 7;
          if (res.data.code == 200) {
            dayCount = data.maxDays;
            this.sendPrice = data.minDeliveryAmount;
            sessionStorage.setItem("packPrice", data.packPrice);
            sessionStorage.setItem("deliveryPrice", data.deliveryPrice);
          }
          this.createTime(dayCount);
        });
    },
    //生成时间
    createTime(dayCount) {
      let nowDate = new Date();
      nowDate.setHours(1);
      nowDate.setMinutes(1);
      let dateArr = Array(dayCount)
        .fill(0)
        .map((_, i) => {
          let data = utils.formatDate(nowDate);
          let weekIndex = nowDate.getDay();
          let week = this.weekDay[weekIndex];
          nowDate.setDate(nowDate.getDate() + 1);
          return data + " " + week;
        });
      this.dateArr = dateArr;
      const lastDate = this.dateArr[this.dateArr.length - 1];
      this.maxDate = new Date(lastDate.substring(0, 10));
    },
    //选择日期
    handleChangeTime(index, item) {
      this.timeIndex = index;
      this.mealIndex = 0;
      this.mealPeriodTime = item;
      this.getMenuList();
      this.selectShopList = [];
      this.selectMenuCount = 0;
      this.selectedMenuId = 0;
    },
    //获取菜品餐段及餐段列表
    getMenuList() {
      try {
        this.$toast.loading({
          message: this.language == "CN" ? "加载中..." : "Loading...",
          forbidClick: true,
          loadingType: "spinner",
        });
        this.mealPeriod = [];
        this.productCateforyList = [];
        this.productCateList = [];
        this.allCateList = [];
        let roles = JSON.parse(localStorage.getItem("customerInfoList"));
        const customerId =
          (roles && roles[0].customerId) || localStorage.getItem("customerId");
        let data = {
          shopId: this.shopId,
          branchId: this.branchId,
          customerId: customerId,
          targetDate: this.mealPeriodTime,
        };
        this.$authAjax
          .post("/api/wxapp/reserve/findMenuProducts", data)
          .then((res) => {
            this.$toast.clear();
            const { data } = res.data;
            this.selectMealList = data;
            (data || []).forEach((item) => {
              this.mealPeriod.push({
                id: item.id,
                mealHourName:
                  this.language == "CN"
                    ? item.mealHourName
                    : item.mealHourNameEn,
                mealHourTime:
                  item.mealHourTime.substring(0, 5) +
                  "-" +
                  item.mealHourTime.substring(11, 16),
              });
              sessionStorage.setItem(
                "selectTime",
                JSON.stringify(this.mealPeriod[0])
              );
            });
            if (this.mealPeriod.length != 0) {
              this.mealHourName = this.mealPeriod[0].mealHourName;
              this.mealHourTime = this.mealPeriod[0].mealHourTime;
            }
            if (data != null) {
              this.productCateforyList = data[0].productCateforyList;
              this.productCateList = JSON.parse(
                JSON.stringify(this.productCateforyList)
              );
              this.allCateList = JSON.parse(
                JSON.stringify(data[0].productCateforyList)
              );
            }
            if (res.data.code != 200) {
              this.$toast(res.data.message);
            }
          });
      } finally {
        this.$toast.clear();
      }
    },
    //选择餐段
    handleSelectMeal(index, item) {
      this.selectShopList = [];
      this.selectMenuCount = 0;
      this.productCateforyList = [];
      this.mealIndex = index;
      this.mealHourName = item.mealHourName;
      this.mealHourTime = item.mealHourTime;
      this.selectMealList.map((item0) => {
        if (
          (this.language == "CN" ? item0.mealHourName : item0.mealHourNameEn) ==
          this.mealHourName
        ) {
          this.productCateforyList = item0.productCateforyList;
          this.productCateList = JSON.parse(
            JSON.stringify(this.productCateforyList)
          );
          this.allCateList = JSON.parse(
            JSON.stringify(item0.productCateforyList)
          );
        }
      });
      sessionStorage.setItem("selectTime", JSON.stringify(item));
      for (let i = 0; i < this.productCateforyList.length; i++) {
        for (
          let j = 0;
          j < this.productCateforyList[i].productList.length;
          j++
        ) {
          this.productCateforyList[i].productList[j].count = 0;
        }
      }
    },
    //改变左边side栏
    handleChangeLeftSide(index) {
      this.selectedMenuId = index;
      this.$el.querySelector(`#id${index}`).scrollIntoView({
        behavior: "smooth", // 平滑过渡
        block: "start", // 上边框与视窗顶部平齐。默认值
      });
      this.listBoxState = false;

      let timeId;
      clearTimeout(timeId);
      timeId = setTimeout(() => {
        this.listBoxState = true;
      }, 1000);
    },
    //滚动右侧事件
    scrollToTop() {
      var domHight = document.body.offsetHeight;
      // dom滚动位置
      if (!this.$refs.content) return;
      // var scrollTop =
      let scrollTop = this.$refs.content.scrollTop;
      //   window.pageYOffset ||
      //   document.documentElement.scrollTop ||
      //   document.body.scrollTop;
      if (this.listBoxState) {
        for (let i = 0; i < this.productCateforyList.length; i++) {
          const el = document.getElementById(`id${i}`);
          if (!el) break;
          // 获取监听元素距离视窗顶部距离
          var offsetTop = el.offsetTop;
          // 获取监听元素本身高度
          var scrollHeight = el.scrollHeight;
          // 如果 dom滚动位置 >= 元素距离视窗距离 && dom滚动位置 <= 元素距离视窗距离+元素本身高度
          // 则表示页面已经滚动到可视区了。
          if (scrollTop >= offsetTop && scrollTop <= offsetTop + scrollHeight) {
            // 导航栏背景色选中
            this.selectedMenuId = i;
          }
        }
      }
    },
    //增加数量
    handleAdd(data) {
      if (data.count >= data.productNum) {
        return this.$toast(this.$t("Insufficient"));
      }
      if (
        data.productPurchasingNum != 0 &&
        data.count >= data.productPurchasingNum
      ) {
        return this.$toast(this.$t("purchaseLimit"));
      }
      data.count++;
      this.selectMenuCount++;
      this.selectShopList = [];
      for (let i = 0; i < this.productCateList.length; i++) {
        for (let j = 0; j < this.productCateList[i].productList.length; j++) {
          if (this.productCateList[i].productList[j].id == data.id) {
            this.productCateList[i].productList[j].count = data.count;
          }
          if (this.productCateList[i].productList[j].count > 0) {
            this.selectShopList.push(this.productCateList[i].productList[j]);
          }
        }
      }
      for (let i = 0; i < this.productCateforyList.length; i++) {
        for (
          let j = 0;
          j < this.productCateforyList[i].productList.length;
          j++
        ) {
          if (this.productCateforyList[i].productList[j].id == data.id) {
            this.productCateforyList[i].productList[j].count = data.count;
          }
        }
      }
      for (let i = 0; i < this.selectShopList.length; i++) {
        for (let j = 1; j < this.selectShopList.length; j++) {
          if (
            this.selectShopList[i].id == this.selectShopList[j].id &&
            i !== j
          ) {
            this.selectShopList[i].count = this.selectShopList[j].count;
            this.selectShopList.splice(j, 1);
          }
        }
      }
    },
    //减少数量
    handleMinusCount(data) {
      if (data.count == "0") {
        return;
      }
      data.count--;
      this.selectMenuCount--;
      for (let i = 0; i < this.productCateList.length; i++) {
        for (let j = 0; j < this.productCateList[i].productList.length; j++) {
          if (this.productCateList[i].productList[j].id == data.id) {
            this.productCateList[i].productList[j].count = data.count;
          }
        }
      }
      for (let i = 0; i < this.productCateforyList.length; i++) {
        for (
          let j = 0;
          j < this.productCateforyList[i].productList.length;
          j++
        ) {
          if (this.productCateforyList[i].productList[j].id == data.id) {
            this.productCateforyList[i].productList[j].count = data.count;
          }
        }
      }
      if (data.count == 0) {
        let index = this.selectShopList.findIndex((item) => {
          return data.id == item.id;
        });
        this.selectShopList.splice(index, 1);
      }
      if (!this.selectShopList.length) {
        this.priceMinus = this.sendPrice;
        this.minusFlag = false;
      }
    },
    //弹出购物车
    handleShowShoping() {
      this.shopShow = true;
    },
    //减少购物车数量
    handleLoseShopCount(item) {
      item.count--;
      this.selectMenuCount--;
      for (let i = 0; i < this.productCateforyList.length; i++) {
        for (
          let j = 0;
          j < this.productCateforyList[i].productList.length;
          j++
        ) {
          if (this.productCateforyList[i].productList[j].id == item.id) {
            this.productCateforyList[i].productList[j].count = item.count;
          }
        }
      }
      for (let i = 0; i < this.productCateList.length; i++) {
        for (let j = 0; j < this.productCateList[i].productList.length; j++) {
          if (this.productCateList[i].productList[j].id == item.id) {
            this.productCateList[i].productList[j].count = item.count;
          }
        }
      }
      if (item.count == 0) {
        let index = this.selectShopList.findIndex((data) => {
          return item.id == data.id;
        });
        this.selectShopList.splice(index, 1);
      }
    },
    //增加购物车数量
    handleAddShopCount(item) {
      if (item.count >= item.productNum) {
        return this.$toast(this.$t("Insufficient"));
      }
      if (
        item.productPurchasingNum != 0 &&
        item.count >= item.productPurchasingNum
      ) {
        return this.$toast(this.$t("purchaseLimit"));
      }
      item.count++;
      this.selectMenuCount++;
      for (let i = 0; i < this.productCateforyList.length; i++) {
        for (
          let j = 0;
          j < this.productCateforyList[i].productList.length;
          j++
        ) {
          if (this.productCateforyList[i].productList[j].id == item.id) {
            this.productCateforyList[i].productList[j].count = item.count;
          }
        }
      }
      for (let i = 0; i < this.productCateList.length; i++) {
        for (let j = 0; j < this.productCateList[i].productList.length; j++) {
          if (this.productCateList[i].productList[j].id == item.id) {
            this.productCateList[i].productList[j].count = item.count;
          }
        }
      }
    },
    //清空购物车
    handleClearShop() {
      this.selectShopList = [];
      this.selectMenuCount = 0;
      for (let i = 0; i < this.productCateforyList.length; i++) {
        for (
          let j = 0;
          j < this.productCateforyList[i].productList.length;
          j++
        ) {
          this.productCateforyList[i].productList[j].count = 0;
        }
      }
      for (let i = 0; i < this.productCateList.length; i++) {
        for (let j = 0; j < this.productCateList[i].productList.length; j++) {
          this.productCateList[i].productList[j].count = 0;
        }
      }
    },
    //去下单
    handleSubmitOrder() {
      if (!this.selectMenuCount) {
        return this.$toast(this.$t("noSelectShop"));
      }
      console.log(this.mealHourName, 'mealHourName==');
      
      sessionStorage.setItem("mealList", JSON.stringify(this.selectShopList));
      this.$router.push({
        path: "/order/submit",
        query: {
          mealPeriodTime: this.mealPeriodTime,
          mealHourName: this.mealHourName,
          mealHourTime: this.mealHourTime,
          branchId: this.branchId,
          branchName: this.branchName,
          type: this.$route.query.type || this.$route.params.type,
        },
      });
    },
    // 筛选菜品
    handleInputData() {
      let newDataList = JSON.parse(JSON.stringify(this.productCateList));
      this.productCateforyList = newDataList.filter((item) => {
        item.productList = item.productList.filter((resData) => {
          return resData.name.includes(this.searchText);
        });
        return item;
      });
    },
    // 选择菜品数量
    handleSelectMenuCount(item) {
      if (!item.count) return;
      this.selectCountRow = item;
      this.showMenuDesciption = true;
    },
    handleConfirmCount() {
      if (!this.placeCount) {
        return this.$toast(this.$t("nullExplain"));
      }
      if (this.placeCount >= this.selectCountRow.productNum) {
        return this.$toast(this.$t("Insufficient"));
      }
      if(this.placeCount == 0) {
        return this.$toast(this.$t('verification'))
      }
      this.selectMenuCount =
        this.selectMenuCount -
        this.selectCountRow.count +
        Number(this.placeCount);
      this.selectShopList = [];
      this.selectCountRow.count = this.placeCount;
      for (let i = 0; i < this.productCateList.length; i++) {
        for (let j = 0; j < this.productCateList[i].productList.length; j++) {
          if (
            this.productCateList[i].productList[j].id == this.selectCountRow.id
          ) {
            this.productCateList[i].productList[
              j
            ].count = this.selectCountRow.count;
          }
          if (this.productCateList[i].productList[j].count > 0) {
            this.selectShopList.push(this.productCateList[i].productList[j]);
          }
        }
      }
      for (let i = 0; i < this.productCateforyList.length; i++) {
        for (
          let j = 0;
          j < this.productCateforyList[i].productList.length;
          j++
        ) {
          if (
            this.productCateforyList[i].productList[j].id ==
            this.selectCountRow.id
          ) {
            this.productCateforyList[i].productList[
              j
            ].count = this.selectCountRow.count;
          }
        }
      }
      for (let i = 0; i < this.selectShopList.length; i++) {
        for (let j = 1; j < this.selectShopList.length; j++) {
          if (
            this.selectShopList[i].id == this.selectShopList[j].id &&
            i !== j
          ) {
            this.selectShopList[i].count = this.selectShopList[j].count;
            this.selectShopList.splice(j, 1);
          }
        }
      }
      this.placeCount = null;
    },
    // 获取排队人数
    async getQueueUp() {
      try {
        const { data } = await this.$authAjax.post(
          "/api/wxapp/new/reserve/order/call/waiting/count",
          {
            shopId: this.shopId,
            branchId: this.branchId,
          }
        );
        if (data.code == 200) {
          let resData = data.data;
          this.peopleNum = resData.count || 0;
          this.estimatedTime = resData.count * 0.5 || 0;
        }
      } catch (err) {
        console.log(err);
      }
    },
    // 获取叫号号码
    async getWatingNum() {
      try {
        const { data } = await this.$authAjax.post(
          "/api/wxapp/new/reserve/order/call/list/query",
          {
            shopId: this.shopId,
            branchId: this.branchId,
          }
        );
        if (data.code == 200) {
          const num = data.callingList?.[0];
          this.WaitingISNum = num ? num : "001";
        }
      } catch (err) {
        console.log(err);
      }
    },
    // 选择日历
    handleConfirmSelectCalendar(e) {
      let date = utils.formatDate(e);
      let weekIndex = e.getDay();
      let week = this.weekDay[weekIndex];
      this.mealPeriodTime = date + " " + week;
      const index = this.dateArr.findIndex(
        (item) => item == this.mealPeriodTime
      );
      this.timeIndex = index;
      this.mealIndex = 0;
      this.getMenuList();
      this.selectShopList = [];
      this.selectMenuCount = 0;
      this.selectedMenuId = 0;
      this.showSelectCalendar = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.menu-main {
  font-size: 16px;
  box-sizing: border-box;
  overflow: hidden;
  //头部时间选择
  .header-calendar-select {
    display: flex;
    align-items: center;
    .calendar-main {
      flex: 1;
      background: #0686cb;
      height: 48px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 3px;
      font-size: 12px;
      color: #fff;
      box-shadow: -1px 0 6px rgba(0, 0, 0, 0.5);
    }
  }
  .head-tabar {
    height: 48px;
    background-color: #0686cb;
    display: flex;
    align-items: center;
    width: 85%;
    overflow-x: auto;
    // margin-top: 45px;
    .time-item {
      flex-shrink: 0;
      margin: 0 6px;
      border-radius: 5px;
      height: 40px;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      font-size: 12px;
      color: #ffffff;
      text-align: center;
      .time-week {
        width: 40px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    .selectTime {
      background: #023f86;
      color: #fff;
    }
  }
  //餐段选择
  .meal-period {
    height: 40px;
    display: flex;
    background-color: #ffffff;
    border-bottom: 1px solid #f9f9f9;
    .meal-item {
      width: 25%;
      color: #cccccc;
      font-size: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
    }
    .selectMeal {
      color: #2ab1e7;
      font-size: 14px;
    }
  }
  .search-main {
    padding: 0 16px;
    ::v-deep .van-search {
      padding: 0;
    }
  }
  //主体
  .select-menu-main {
    height: calc(100vh - 130px);
    overflow: hidden;
    display: flex;
    .left-side {
      display: flex;
      width: 100px;
      padding-bottom: 40px;
      background-color: #f0f0f0;
      flex-direction: column;
      border-right: 1px solid #f4f5f6;
      overflow: auto;
      .menu-item {
        width: 78px;
        padding: 12px 0;
        color: #666;
        text-align: center;
        translate: all 0.2s;
        font-size: 14px;
      }
      .left-item-title {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
        text-overflow: ellipsis;
        word-break: break-word;
      }
      .m-item-active {
        background-color: #ffffff;
        color: #2ab1e7;
        position: relative;
        border-radius: 0 -20px 0 -20px;
        &::after {
          content: "";
          width: 4px;
          height: 28px;
          background-color: #2ab1e7;
          position: absolute;
          left: 0;
          top: calc(50% - 14px);
        }
        .m-item-title {
          color: #4ca1fb;
          font-weight: bold;
        }
      }
    }
    #rightTop {
      position: relative;
    }
    .right-side {
      width: 100%;
      padding-bottom: 40px;
      overflow: auto;
      .dish-title {
        font-size: 14px;
        color: #565754;
        border-bottom: 1px solid #f9f9f9;
        padding: 7px 0;
        margin-bottom: 3px;
        padding-left: 12px;
        position: sticky;
        top: 0;
        background-color: #fff;
        z-index: 2;
      }
      .dish-item {
        width: 95%;
        padding: 8px 0;
        padding-left: 12px;
        border-bottom: 1px solid #f4f5f6;
        &-wrp {
          width: 100%;
          display: flex;
          flex-direction: row;
          align-items: center;
          // justify-content: space-around;
        }
        &-pic {
          width: 85px;
          height: 85px;
          img {
            width: 85px;
            height: 85px;
            margin: 0 auto;
            border-radius: 5px;
          }
        }
        &-info {
          width: 80px;
          padding-left: 12px;
          // margin-left: -5px;
          position: relative;
        }
        &-name {
          color: #333333;
          font-size: 14px;
          font-weight: bold;
          word-break: break-word;
        }
        &-sales {
          color: #999;
          font-size: 10px;
          margin-top: 6px;
        }
        &-money {
          color: #333333;
          font-size: 16px;
          font-weight: bold;
          margin-top: 8px;
        }
        .preferential {
          display: flex;
          align-items: center;
          .vipPrice {
            font-size: 17px;
            font-weight: bold;
            color: #ff1a1a;
            line-height: 19px;
          }
          .menuPrice {
            font-size: 12px;
            font-weight: 400;
            color: #b0b0b0;
            line-height: 19px;
            text-decoration: line-through;
            margin-left: 6px;
          }
        }
        &-count {
          // margin-left: 5px;
          padding-left: 10px;
          display: flex;
          justify-content: space-around;
          align-items: center;
          .count-pic {
            width: 25px;
            height: 25px;
          }
          div:nth-child(2) {
            color: #ccc;
            font-size: 14px;
            line-height: 25px;
            text-align: center;
            // margin: 0 8px;
          }
        }
        .pay-null {
          font-size: 14px;
          font-weight: 300;
          color: #c0c0c0;
          line-height: 16px;
          margin-left: 26px;
        }
        &-tab {
          width: 25px;
          height: 25px;
        }
        .showMinus {
          opacity: 1;
        }
        .hiddenMinus {
          opacity: 0;
        }
      }
      .show__meal_count {
        border: 1px solid #eee;
      }
    }
  }

  .nullImg {
    margin: auto;
    width: 175px;
    height: 175px;
    margin-top: 150px;
  }
  //底部
  .call-info {
    width: 100%;
    padding: 6px 0;
    background: #e8f3ff;
    position: fixed;
    bottom: 50px;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 25px;
    z-index: 3;
    span {
      font-weight: 500;
      font-size: 10px;
      color: #333333;
    }
    .peo-c {
      color: #f65a5a;
    }
  }

  .footer-main {
    width: 100%;
    height: 50px;
    position: fixed;
    bottom: 0;
    left: 0;
    background: #fff;
    border-top: 1px solid #f9f9f9;
    z-index: 999;
    .footImg {
      position: absolute;
      top: -50%;
      left: 2%;
      img {
        width: 60px;
        height: 60px;
      }
    }
    .menu-nun {
      display: inline-block;
      width: 18px;
      height: 18px;
      font-size: 11px;
      color: white;
      line-height: 18px;
      border-radius: 25px;
      text-align: center;
      position: absolute;
      right: 5px;
      background: red;
    }
    .menu-prompt {
      color: #999999;
      font-size: 12px;
      display: inline-block;
      padding-left: 65px;
      line-height: 50px;
    }
    .menu-price {
      font-size: 20px;
      color: #ed7e05;
    }
    .place-order {
      padding: 8px 12px;
      display: block;
      font-size: 14px;
      background: #d4effa;
      color: #82cce9;
      text-align: center;
      border-radius: 20px;
      position: absolute;
      right: 8px;
      top: 50%;
      transform: translateY(-50%);
    }
    .active-btn {
      background: #2aafe4;
      color: #ffffff;
    }
  }
  //购物车弹窗
  .shop-main {
    width: 100%;
    // padding: 10px 10px 0 10px;
    box-sizing: border-box;
    .shop-head {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 40px;
      line-height: 40px;
      padding: 0 10px;
      border-bottom: 1px solid #ccc;
      position: sticky;
      top: 0;
      background: #fff;
      div:nth-child(2) {
        color: #4ca1fb;
      }
    }
    .shop-item {
      height: 50px;
      line-height: 50px;
      padding: 0 10px;
      border-bottom: 1px solid #ccc;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .price-count {
        display: flex;
        align-items: center;
        .price {
          margin-right: 25px;
        }
        .selectCount {
          display: flex;
          align-items: center;
          .num {
            width: 25px;
            height: 25px;
            line-height: 25px;
            text-align: center;
            color: #ccc;
          }
        }
      }
    }
    .notMenul {
      text-align: center;
      margin-top: 20px;
    }
  }
}
.dialog-explice {
  min-height: 120px;
  padding: 10px;
  box-sizing: border-box;
  .text {
    font-size: 18px;
    display: flex;
    margin-top: 8px;
    line-height: 26px;
    .title {
      white-space: nowrap;
    }
  }
}
.menu-decritipn {
  padding: 12px;
  line-height: 28px;
}
</style>
